import React, { useState, useEffect } from 'react'
import InputEnter from '../../generic/InputEnter'
import * as Icons from 'react-feather'

function SelectDateComponent({ updateDateSelection, selectedYear, selectedMonth }) {
	const [dropdownOpen, setDropdownOpen] = useState(false)

	const months = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December',
	]

	useEffect(() => {
		const previousMonthDate = new Date(new Date().setMonth(new Date().getMonth() - 1))
		updateDateSelection(previousMonthDate.getFullYear(), months[previousMonthDate.getMonth()])
	}, [])

	const handleYearChange = (e) => {
		const year = e.target.value
		updateDateSelection(year, selectedMonth)
	}

	const handleMonthSelection = (month) => {
		updateDateSelection(selectedYear, month)
	}

	return (
		<div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
			<InputEnter
				value={selectedYear}
				onChange={handleYearChange}
				placeholder='Enter year'
				type='number'
				showEnterButton={false}
			/>
			<div
				className='dropdown'
				onClick={() => setDropdownOpen(!dropdownOpen)}
				style={{ height: '52px', top: '10px' }}
			>
				<span
					style={{
						paddingRight: '20px',
						whiteSpace: 'nowrap',
						overflow: 'hidden',
						textOverflow: 'ellipsis',
					}}
				>
					{selectedMonth ? selectedMonth : 'Select month'}
				</span>
				<Icons.ArrowDown
					style={{
						position: 'absolute',
						top: '15px',
						right: '10px',
						height: '20px',
						width: '20px',
					}}
				/>
				{dropdownOpen ? (
					<div style={{ width: '120px', left: '0px' }}>
						{months.map((month) => (
							<p
								key={month}
								style={{ padding: '9px 15px' }}
								onClick={() => handleMonthSelection(month)}
							>
								{month}
							</p>
						))}
					</div>
				) : null}
			</div>
		</div>
	)
}

export default SelectDateComponent
